export enum InvoiceTypesEnum {
  DEFAULT = 'DEFAULT',
  CREDIT = 'CREDIT',
  CREDIT_ACCOUNTING = 'CREDIT_ACCOUNTING',
}
